import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import KeyValueItem from "entities/KeyValueItem";
import i18n from "i18n";
import { apiCallBegan } from "store/api";
import { AppDispatch, AppState } from "store/configureStore";
import SliceCollectionBase from "store/types/SliceCollectionBase";
import { authHeader } from "store/users/auth";

interface KeyValueResponse {
    Id: number;
    Name: string;
}

interface State extends SliceCollectionBase<KeyValueItem> { }

const initialState: State = {
  list: [],
  loading: false,
  lastFetch: null,
  error: null
}


const slice = createSlice({
    name: "virtualTeams",
    initialState,
    reducers: {
    virtualTeamsRequested: (virtualTeams) => {
      virtualTeams.loading = true;
      virtualTeams.error = null;
    },
    virtualTeamsReceived: (virtualTeams, action: PayloadAction<KeyValueResponse[]>) => {
      virtualTeams.list = schema(action.payload);
      virtualTeams.loading = false;
      virtualTeams.lastFetch = Date.now();
    },
    virtualTeamsRequestFailed: (virtualTeams, action) => {
      virtualTeams.loading = false;
      virtualTeams.error = action.payload;
    }
   }
});

const {
  virtualTeamsRequested,
  virtualTeamsReceived,
  virtualTeamsRequestFailed
} = slice.actions;

export const getCompanyvirtualTeams = () => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (getState().entities.virtualTeams.loading) {
    return;
  }

  const companyId = getState().users.auth.data?.CompanyId ?? 0;

  const url = `api/workdetails/teams/${companyId}`;

  var result =  dispatch(
      apiCallBegan({
          url,
          method: "GET",
          headers: { ...authHeader(), "Accept-Language": i18n.language },
          onStart: virtualTeamsRequested.type,
          onSuccess: virtualTeamsReceived.type,
          onError: virtualTeamsRequestFailed.type
      })
  );
  return result
}

const schema = (payload: KeyValueResponse[]): KeyValueItem[] => {
  if (!payload || payload.length === 0) {
    return [];
  }

  return payload.map((resp: KeyValueResponse): KeyValueItem => (
    {
      id: resp.Id,
      value: resp.Name
    }
  ))
};

export default slice.reducer;
